import WebPAge from './components/WebPage';

import './App.css';

const App = () => (
  <WebPAge />
)
export default App;
